<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row" *ngIf="!isWorldPay()">
  <div class="row mt-4">
    <div class="col-md-12">
      <legend class="row">
        <div class="col-md-6 m-auto" *ngIf="!editable">
          Payment Processor Information
        </div>
        <div class="col-md-6">
          <!--Get the mf-edit-button-->
          <button
            class="btn btn-primary float-right"
            *ngIf="
              isUserBase() && !isWorldPay() && isMerchantActive() && !editable
            "
            (click)="setEditable(true)"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit Merchant Info
          </button>
        </div>
      </legend>
    </div>
  </div>

  <div *ngIf="!editable">
    <app-payment-processor-info
      [merchant]="merchant"
    ></app-payment-processor-info>
    <div class="col-md-12 removePadding">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">General Merchant Info</div>
      </legend>
      <app-general-info [merchant]="merchant"></app-general-info>
    </div>

    <div *ngIf="!isInstaMed()" class="col-md-12 removePadding">
      <legend class="row ml-sm-0 mt-4 mb-3 borderDivide">
        <div class="borderSeparation">Customer Contact</div>
      </legend>
      <app-customer-contact [merchant]="merchant"></app-customer-contact>
    </div>

    <div *ngIf="!isInstaMed()" class="col-md-12 removePadding">
      <legend class="row ml-sm-0 mt-4 mb-3 borderDivide">
        <div class="borderSeparation">Merchant Address</div>
      </legend>
      <app-merchant-address [merchant]="merchant"></app-merchant-address>
    </div>

    <div *ngIf="!isInstaMed()" class="col-md-12 removePadding">
      <legend class="row ml-sm-0 mt-4 mb-3 borderDivide">
        <div class="borderSeparation">Legal Entity</div>
      </legend>
      <app-legal-entity [merchant]="merchant"></app-legal-entity>
    </div>

    <div class="col-md-12 removePadding">
      <legend class="row ml-sm-0 mt-4 mb-4 borderDivide">
        <div class="borderSeparation">Accepted Credit Cards</div>
      </legend>
      <app-accepted-credit-cards
        [merchant]="merchant"
      ></app-accepted-credit-cards>
    </div>
  </div>

  <div class="mt-3" *ngIf="editable">
    <form
      name="generalInfoFormControl"
      class="form-horizontal"
      novalidate
      [formGroup]="merchantDetailsForm"
      (submit)="updateGeneralInfo()"
    >
      <legend class="row ml-sm-0 mb-3">
        <div class="col-md-6 offset-md-3">General Merchant Info</div>
      </legend>
      <app-general-info-edit
        [parentGroup]="merchantDetailsForm"
        [generalInfo]="this.generalInfoFormGroup"
        [isEditable]="editable"
        [merchant]="merchant"
        [hiddenField]="false"
      >
      </app-general-info-edit>
      <div *ngIf="!isInstaMed()">
        <legend class="row ml-sm-0 mt-4 mb-3">
          <div class="col-md-6 offset-md-3">Customer Contact</div>
        </legend>
        <app-customer-contact-edit
          [contacts]="this.contactsFormGroup"
          [parentGroup]="merchantDetailsForm"
          [merchant]="merchant"
        ></app-customer-contact-edit>
      </div>

      <div *ngIf="!isInstaMed()">
        <legend class="row ml-sm-0 mt-4 mb-3">
          <div class="col-md-6 offset-md-3">Merchant Address</div>
        </legend>
        <app-merchant-address-edit
          [parentGroup]="merchantDetailsForm"
          [merchantAddress]="this.merchantAddressFormGroup"
          [remitToAddress]="this.remitAddressFormGroup"
          [merchant]="merchant"
          (hasRemitAddress)="hasRemitEvent($event)"
        >
        </app-merchant-address-edit>
      </div>

      <div *ngIf="!isInstaMed()">
        <legend class="row ml-sm-0 mt-4 mb-3">
          <div class="col-md-6 offset-md-3">Legal Entity</div>
        </legend>
        <app-legal-entity-edit
          [parentGroup]="merchantDetailsForm"
          [legalEntity]="this.legalEntityFormGroup"
          [merchant]="merchant"
        >
        </app-legal-entity-edit>
      </div>

      <legend class="row ml-sm-0 mt-4 mb-4">
        <div class="col-md-6 offset-md-3">Accepted Credit Cards</div>
      </legend>
      <app-accepted-credit-cards-edit
        [parentGroup]="merchantDetailsForm"
        [acceptedCards]="this.acceptedCardsFormGroup"
        [merchant]="merchant"
        [isEditable]="true"
      >
      </app-accepted-credit-cards-edit>
      <app-edit-buttons
        [buttonName]="buttonName"
        [actionInProgress]="actionInProgress"
        [formInvalid]="merchantDetailsForm.invalid"
        (editableEvent)="receiveEditEvent($event)"
      ></app-edit-buttons>
    </form>
  </div>
</div>
